import { Action } from "../components/Actions";
import { EditorialShell } from "../components/EditorialShell";
import { RecordCollage } from "../components/RecordCollage";
import { ALBUMS } from "../data/albums";
import { songsByAlbum } from "../data";

interface AlbumCloseupScreenProps {
  index: number;
  selected: string;
  onConfirm(): void;
  onBack(): void;
}

export function AlbumCloseupScreen({ index, selected, onConfirm, onBack }: AlbumCloseupScreenProps) {
  const album = ALBUMS[index];
  const selectedSong = (songsByAlbum.get(album.name) ?? []).find((song) => song.song === selected);
  return (
    <EditorialShell className="closeup-page">
      <section className="closeup-layout page-enter" aria-labelledby="closeup-title">
        <div className="closeup-cover-wrap">
          <img className="closeup-cover" src={album.cover} alt={`${album.name} 专辑封面`} />
          <RecordCollage variant="cassette" />
          <span className="closeup-index">{String(index + 1).padStart(2, "0")} / 09</span>
        </div>
        <div className="closeup-copy">
          <div>
            <h1 id="closeup-title">{album.name}</h1>
            <p className="closeup-year">{album.year}</p>
          </div>
          <p className="closeup-prompt">{album.prompt}</p>
          {selectedSong ? <div className="closeup-tags" aria-label="歌曲关键词">{selectedSong.themes.slice(0, 4).map((theme) => <span key={theme}>{theme}</span>)}</div> : null}
          <div className="selected-note">
            <span>你选择了：</span>
            <strong>{selected}</strong>
            {selectedSong ? <p>{selectedSong.compact}</p> : null}
          </div>
          <div className="closeup-actions">
            <Action tone="text" onClick={onBack}>返回曲目单</Action>
            <Action onClick={onConfirm}>确认这首歌</Action>
          </div>
        </div>
      </section>
    </EditorialShell>
  );
}
